import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import CreateEvent from "@/pages/CreateEvent";
import EventDetail from "@/pages/EventDetail";
import EventPlayer from "@/pages/EventPlayer";
import Contribute from "@/pages/Contribute";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-[var(--em-ink-soft)]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton theme="light" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/events/new" element={<Protected><CreateEvent /></Protected>} />
            <Route path="/events/:id" element={<Protected><EventDetail /></Protected>} />
            <Route path="/events/:id/play" element={<Protected><EventPlayer /></Protected>} />
            <Route path="/c/:shareToken" element={<Contribute />} />
            <Route path="/c/:shareToken/play" element={<EventPlayer publicMode />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
